import styled, { css } from "styled-components";
import { ToggleButtonGroup as ToggleButtonGroupPrimitive } from "react-aria-components";
import { CoreButtonGroup } from "@boi/components-core";
import { useDesignTokens } from "@boi/react-design-tokens";

type ToggleButtonGroupProps = {
  $variant: CoreButtonGroup.Variant;
};

export const ToggleButtonGroup = styled(
  ToggleButtonGroupPrimitive
)<ToggleButtonGroupProps>`
  ${({ $variant }) => {
    const { tokens } = useDesignTokens();
    const { buttonGroup, breakpoint } = tokens;

    return [
      css`
        all: unset;
        box-sizing: border-box;
        display: flex;
        gap: ${buttonGroup.items.gap};
        width: 100%;
        max-width: ${buttonGroup.maxWidth[$variant]};
      `,
      $variant === "center" &&
        css`
          justify-content: center;
        `,
      $variant === "stacked" &&
        css`
          flex-direction: column;

          @media (min-width: ${breakpoint.mobile}) {
            display: inline-flex;
          }
        `,
    ];
  }}
`;
